import React from 'react';
import { Switch, Route } from 'react-router-dom';
import MiniView from '../pages/mini_view';

const Router = () => (
	<Switch>
		<Route exact path='/mini-view' component={MiniView} />
	</Switch>
);

export default Router;